import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-teamblock',
  templateUrl: './teamblock.component.html',
  styleUrls: ['./teamblock.component.css']
})
export class TeamblockComponent implements OnInit {
  public policy_type:string='Event';
  public eventcode:string='main_2023';
  constructor(private httpClient: HttpClient,private Activatedroute:ActivatedRoute) { }
  // pagination
  page: number = 1;
  public speaker:any = [];
  public eventspeaker:any = [];

  ngOnInit(): void {

    this.policy_type =
    this.Activatedroute.snapshot.queryParamMap.get('speaker_type') || 'Event';
    this.eventcode =
    this.Activatedroute.snapshot.queryParamMap.get('eventcode') || 'main_2023';
    this.Activatedroute.queryParams.subscribe(queryParams => {
      this.policy_type = queryParams.speaker_type;
      this.eventcode = queryParams.eventcode;
    });
    this.httpClient.get('/api/trainingspeakers').subscribe(
      data=>{

        var val:any = data;
        this.speaker = val.sort(function(a:any, b:any) {
          if(Number(a.ordering) >Number(b.ordering))
          {
            return 1
          }
          else if(Number(a.ordering) <Number(b.ordering))
          {
            return -1
          }
    return 0;
});
      }
    );
  }
  findSpeakerType(speaker: any[]): any[] {
    return speaker.filter(p => p.speakertype == this.policy_type && p.eventcode == this.eventcode);
  }

}
